// frontend/src/utils/agentGrouping.js

// Groups a flat list of items (customers) under a flat list of agents
// (id, parent_id) into a tree: top-level agent nodes (those with no parent,
// or a parent not present in `agents`), each carrying its own items plus
// nested sub-agent nodes recursively. Items with no matching agent_id land
// in a separate `direct` bucket (customers created directly by the book).
//
// getAgentId(item) -> agent id or null/undefined for an item.
export function buildAgentTree(agents, items, getAgentId) {
  const nodeById = new Map(agents.map(a => [a.id, { agent: a, items: [], subAgents: [] }]));
  const roots = [];
  const direct = [];

  items.forEach(item => {
    const agentId = getAgentId(item);
    const node = agentId != null ? nodeById.get(agentId) : null;
    if (node) {
      node.items.push(item);
    } else {
      direct.push(item);
    }
  });

  nodeById.forEach(node => {
    const parentId = node.agent.parent_id;
    const parentNode = parentId != null ? nodeById.get(parentId) : null;
    if (parentNode) {
      parentNode.subAgents.push(node);
    } else {
      roots.push(node);
    }
  });

  return { roots, direct };
}

// True if this node (or any nested sub-agent) has at least one item —
// used to hide agent groups that a text filter has emptied out entirely.
export function nodeHasItems(node) {
  if (node.items.length > 0) return true;
  return node.subAgents.some(nodeHasItems);
}
